import clsx from 'clsx';

interface LogoTileImageProps {
  src: string;
  alt?: string;
  className?: string;
  imageId?: string;
}

// Fits a logo of any ratio inside a square: the logo stays fully visible and
// centred, while a blurred copy of it fills the remaining space.
const LogoTileImage = ({
  src,
  alt = '',
  className,
  imageId
}: LogoTileImageProps) => (
  <div className={clsx('relative size-full overflow-hidden', className)}>
    {/* <img
      src={src}
      alt=""
      aria-hidden
      className="absolute inset-0 size-full scale-125 object-cover blur-lg"
    /> */}
    <img
      data-testid={imageId}
      src={src}
      alt={alt}
      className="relative size-full object-contain"
    />
  </div>
);

export default LogoTileImage;
